var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 966.586,
    height: 447.56,
    viewBox: "0 0 966.586 447.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-747.274 -305.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1202.06,637.849c.99-.095,1.98-.274,2.97-.274q253,0,506.64.425a16.784,16.784,0,0,0,1.9.914v29.768H1195.2c0-10.148,0-20.244.61-30.273C1198.3,638.266,1200.18,638.057,1202.06,637.849Z",
    fill: "#635e5d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M785.543,738.549c-10.78,10.123-23.678,13.579-38.262,14.517,0-12.7-.047-24.989.1-37.273a3.675,3.675,0,0,1,2.164-2.628c8.76-2.619,13.041-9.1,14.4-17.468a161.1,161.1,0,0,0,2.545-25.28q.288-116.246.115-232.492c0-7.771-1.508-9.219-9.432-9.248-3.129-.011-6.258,0-9.662,0V400.367c2.7,0,5.424.011,8.149,0,10.135-.05,10.66-.9,11.025-11.228.451-12.786.278-25.757,2.48-38.278,3.026-17.2,11.441-31.941,28.32-39.225,7.582-3.272,16.256-4.014,25.406-6.128,0,12.217.059,22.822-.109,33.424-.014.878-1.408,2.137-2.427,2.536-13.078,5.123-17.055,16.116-18.082,28.633-.611,7.451-.229,14.992-.132,22.49.076,5.845,2,7.659,7.908,7.759,4.124.069,8.251.013,12.583.013v28.317c-4.21,0-8.172-.031-12.132.008-6.445.062-8.346,1.92-8.359,8.334q-.054,26.25-.024,52.5c0,62.664.146,125.33-.14,187.993-.056,12.1-1.4,24.247-2.917,36.277C797.841,723.46,793.228,731.76,785.543,738.549Z",
    fill: "#635e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1298.58,618.784c14.88-9.382,19.91-23.649,20.96-41.321,1.89,6.514-.2,17.395-4.09,25.109-8.5,16.862-20.9,23.466-39.96,21.292-18.19-2.075-30.34-13.062-34.27-31.89a114.66,114.66,0,0,1-2.26-21.8c-.29-21.16-.1-42.327-.11-63.491v-6.557h-12.48c-.01-.526-.01-1.053-.02-1.579l12.51-.555c0-5.834-.2-11.609.05-17.365.26-5.851-1.39-11.881,2.45-17.425,3.3-4.773,5.59-10.243,8.83-15.063,2.93-4.344,3.69-10.776,10.85-12.809v63.137h40.7c0,.466-.01.932-.01,1.4h-40.24c-.2,1.788-.48,3.045-.48,4.3,0,23.83-.32,47.669.22,71.487.21,8.9,2.42,17.752,3.8,26.612a21.437,21.437,0,0,0,1.4,4.263C1272.37,622,1283.27,626.244,1298.58,618.784Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1656.95,561.129c-5.33.081-10.66.162-16.54-.06a2.045,2.045,0,0,0-1.45.066,16.407,16.407,0,0,1-4.7-.15c-.25-.676-.24-.893.09-1.23.98-1.691,1.62-3.263,2.56-4.942a5.229,5.229,0,0,0-.44-2.376c-.28-2.871-.37-5.365-.59-7.848-1.04-11.623-2.48-23.177-8.07-33.687-4.15-7.8-10.12-13.152-19.52-13.349-9.44-.2-15.79,4.892-19.8,12.751-7.93,15.541-9.42,32.321-8.43,49.818-.01.6,0,.841,0,1.081-.96,15.254.14,30.266,5.77,44.638,3.81,9.726,10.63,15.942,21.78,17.583a3,3,0,0,1,.41,1.395c-24.53.014-40.85-12.053-47.19-35.757-5.63-21.064-5.58-42.238,1.86-62.925,7.35-20.411,23.62-30.905,46.07-30.462,22.88.45,38.91,11.41,45.03,32.5,2.88,9.939,3.29,20.6,4.39,31.442Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1204.96,499.194h8.82V621.627h-21.33V499.194Z",
    fill: "#62605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1355.65,618.24c-14.13-8.1-19.69-21.576-22.45-36.563a114.352,114.352,0,0,1-1.84-19.367c-.23-20.8-.09-41.6-.09-62.782h22.12c0,3.044-.03,6.006,0,8.968.21,24.16.03,48.334.87,72.473.31,8.68,2.63,17.39,4.84,25.874,1.91,7.3,6.97,12.375,14.58,15.468a4.571,4.571,0,0,1,.27,1.962,26.865,26.865,0,0,1-5.61-1.153c-1.96-3.25-3.8-4.248-6.42-1.841a8.757,8.757,0,0,1-2.69-1.4C1358.78,616.187,1357.06,617.666,1355.65,618.24Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M892,623.986c-16.009,4-40.606-2.364-49.883-22.993-3.889-8.648-7.094-18.334-7.49-27.681-1.035-24.43-.349-48.933-.349-73.777h21.583c0,2.06-.018,4,0,5.945.272,25.983.367,51.969.956,77.945a79.44,79.44,0,0,0,3.05,18.658c4.516,16.726,13.992,22.729,31.641,20.742A1.7,1.7,0,0,1,892,623.986Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1129.08,496.457c24.43,2.8,40.44,18.813,42.57,45.684,1.78,22.521,1.12,45.236,1.51,67.865.07,3.783.01,7.568.01,11.6h-22.09c0-1.837.01-3.588,0-5.338-.06-23.15.38-46.316-.4-69.441-.35-10.52-2.54-21.092-4.96-31.391-1.93-8.2-7.62-13.883-16.37-16.77A5.544,5.544,0,0,1,1129.08,496.457Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1086.28,531.046c-.26,3.314-.73,6.626-.74,9.941-.07,24.495-.04,48.99-.04,73.486v7.145h-22.02V497.989c2.34,1.866,4.21,2.7,5.06,4.128,5.17,8.734,10.11,17.6,15.31,27.1A7.229,7.229,0,0,0,1086.28,531.046Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M925.636,596.166a41.3,41.3,0,0,1-2.551-4.459,6.547,6.547,0,0,0-2.379-1.758c.246-2.972.7-5.944.7-8.917q.086-36.931.034-73.863V499.48h21.984V622.548c-1.99-1.339-3.944-1.979-4.755-3.313-4.053-6.669-7.806-13.521-11.722-20.99A6.225,6.225,0,0,0,925.636,596.166Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M985.1,532.178q.141,40.986.282,81.973c.008,2.456,0,4.912,0,7.543H963.5V498.209c2.153,1.694,4.128,2.562,5.029,4.072,5.206,8.716,10.159,17.583,15.462,27.01C984.537,530.661,984.82,531.419,985.1,532.178Z",
    fill: "#62605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1418.18,590.018c.3-2.959.84-5.917.85-8.876q.09-38.432.02-76.863v-4.761h21.87V622.811c-2.17-1.7-4-2.5-4.83-3.9-4.5-7.563-8.75-15.275-13.15-23.658C1422.21,592.084,1421.84,589.352,1418.18,590.018Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1482.11,535.982c.03.167.05.333-.26,1.049a7.188,7.188,0,0,0-.75,2.467c-.02,25.224-.21,50.451.19,75.668.05,3.468-1.69,4.655-3.34,6.54a11.8,11.8,0,0,1-3.65-.294c-5.06-.763-9.59-1.106-14.12-1.449-.03-38.666-.06-77.331.32-116.492a22.384,22.384,0,0,1,4.6-1.5.909.909,0,0,1,.14.737,53.646,53.646,0,0,0,3.84,6.242s-.08.041-.07.413c.99,1.809-2.21,6.134,2.98,4.645,2.85,4.89,5.71,9.779,8.75,15.33.62,1.681,1.05,2.7,1.48,3.723a5.356,5.356,0,0,1-.21,1.71c-.3.507-.44.678-.41.715A5.568,5.568,0,0,0,1482.11,535.982Z",
    fill: "#62605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1218.14,729.3c-1.44,5.724-2.69,11.075-4.23,16.339-.33,1.119-1.71,2.686-2.67,2.735-5.28.268-10.58.128-16.02.128V672.269h33.11C1230.57,692.239,1221.96,710.144,1218.14,729.3Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1713.86,736.975v11.5c-5.62,0-10.91.176-16.17-.158-.97-.062-2.3-2.051-2.65-3.366-4.4-16.884-8.91-33.75-12.83-50.748-1.61-6.971-1.89-14.249-2.84-21.89h34.49Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1667.34,611.506c-.38-12.28,5.57-20.506,16.18-22.854a20.5,20.5,0,1,1-15.24,26.653C1667.91,614.208,1667.69,613.055,1667.34,611.506Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1197.69,424.275c16.19-2.767,25.18,9.608,25.34,19.346a21.169,21.169,0,0,1-17.59,21.134c-9.97,1.625-19.98-5.022-22.86-15.179a20.492,20.492,0,0,1,12.32-24.432C1195.67,424.835,1196.48,424.632,1197.69,424.275Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1449,687.052h216.37v1.512H1234.65c-.01-.5-.01-1.008-.01-1.512Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1001.61,501.55c15.56-11.674,41.87-2.3,48.54,17.382,1.2,3.543,1.81,7.288,2.78,11.313h-22.25c-.57-4.162-1.05-8.242-1.72-12.288a49.235,49.235,0,0,0-1.67-6.759c-4.1-12.97-11.86-15.792-24.65-8.965A2.436,2.436,0,0,1,1001.61,501.55Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1498.62,501.567c9.85-7.826,20.53-5.369,30.74-1.64,12.09,4.411,19.85,17.048,19.81,30.339h-21.56c-.53-3.982-.99-7.894-1.61-11.779a48.8,48.8,0,0,0-1.44-6.309c-4.06-13.822-11.93-16.991-24.92-9.961A2.229,2.229,0,0,1,1498.62,501.567Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1417.99,590.324c3.85-.972,4.22,1.76,4.86,4.6a23.329,23.329,0,0,1-3.16-3.43c-6.91,18.614-16.56,33.735-39.41,32.965a2.809,2.809,0,0,1-.3-1.382c20.41.161,30.7-12.118,36.91-29.61C1417.22,592.531,1417.49,591.575,1417.99,590.324Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1086.53,530.814a4.646,4.646,0,0,1-2.55-1.267c.93-1.873,2.2-3.3,2.88-4.968,5.54-13.694,13.51-24.819,29.11-27.985a19.634,19.634,0,0,1,6.75-.052,2.592,2.592,0,0,1,.3,1.355c-18.92.516-28.81,12.119-34.88,28.413C1087.62,527.709,1087.24,529.158,1086.53,530.814Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M920.458,590.179a4.765,4.765,0,0,1,2.572,1.207c-.926,1.862-2.2,3.286-2.876,4.953-5.3,13.048-12.723,23.933-27.767,27.681-.4-.309-.408-.583-.426-1.271C908.342,617.864,915.607,605.315,920.458,590.179Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M985.414,532.012a7.11,7.11,0,0,1-1.315-2.38c.827-2.087,2.012-3.826,2.759-5.736,3.158-8.073,6.927-15.736,13.862-21.353a1.874,1.874,0,0,1,.37,1.094C993.642,511.773,989.579,521.752,985.414,532.012Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1482.43,532.856a10.279,10.279,0,0,1-1.52-3.213,61.63,61.63,0,0,1,4.04-8.51c4.03-6.362,8.28-12.576,12.88-18.751a5.738,5.738,0,0,1,1.26.656c-7.76,7.253-11.95,16.583-15.8,26.695a4.923,4.923,0,0,0-.74.578c.11.234.26.446.39.666A8.418,8.418,0,0,1,1482.43,532.856Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1634.02,559.875c0,.217-.01.434-.04.976-17.69.367-35.34.409-53.46.4-.46-.29-.47-.53,0-1.164C1598.67,559.755,1616.35,559.815,1634.02,559.875Z",
    fill: "#525051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1465.06,501.6a16.971,16.971,0,0,1-4.51,1.407,13.711,13.711,0,0,1,.59-3.8A23.911,23.911,0,0,1,1465.06,501.6Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1362.18,621.5c2.36-2.625,4.2-1.627,5.79,1.4A28.885,28.885,0,0,1,1362.18,621.5Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1471.96,513.67c-5.16,1.825-1.96-2.5-2.92-4.34A22.5,22.5,0,0,1,1471.96,513.67Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1374.17,624.447a6.453,6.453,0,0,1-.17-1.985,3.085,3.085,0,0,1,2.77.64,6.161,6.161,0,0,1,.33,1.54A18.159,18.159,0,0,1,1374.17,624.447Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1128.78,496.315a5.624,5.624,0,0,1,.24,2.209,3.222,3.222,0,0,1-2.8-.6,6.676,6.676,0,0,1-.33-1.611A19.529,19.529,0,0,1,1128.78,496.315Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1355.85,618.495c1.21-.829,2.93-2.308,3.12,1.2A7.661,7.661,0,0,1,1355.85,618.495Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1377.44,624.72c-.36-.379-.39-.68-.41-1.435a4.041,4.041,0,0,1,2.59-.293c.35.362.33.641.28,1.338A3.949,3.949,0,0,1,1377.44,624.72Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1125.55,496.245c.36.385.39.7.41,1.493a3.87,3.87,0,0,1-2.58.244c-.34-.359-.33-.633-.28-1.319A4.008,4.008,0,0,1,1125.55,496.245Z",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1001.37,503.54c-.29-.17-.3-.437-.34-1.1a.877.877,0,0,1,.39-.809c.35.1.5.282.88.742C1002.24,502.914,1001.95,503.179,1001.37,503.54Z",
    fill: "#646160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1499.23,502.986a2.439,2.439,0,0,1-1.09-.726c-.12-.221.1-.55.29-.622.35.11.51.292.9.758A.364.364,0,0,1,1499.23,502.986Z",
    fill: "#646160"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.689f686a1429a478834691d5fa0329b0.svg";
export { ForwardRef as ReactComponent };